import { useCallback, useEffect, useRef, useState } from 'react';

export const useWakeLock = (enabled) => {
  const lock = useRef(null);
  const [active, setActive] = useState(false);
  const release = useCallback(async () => {
    try { await lock.current?.release?.(); } catch { /* best effort */ }
    lock.current = null; setActive(false);
  }, []);
  useEffect(() => {
    if (!enabled || !('wakeLock' in navigator)) return;
    let disposed = false;
    const acquire = async () => {
      if (document.visibilityState !== 'visible' || (lock.current && !lock.current.released)) return;
      try {
        const next = await navigator.wakeLock.request('screen');
        if (disposed) { await next.release(); return; }
        lock.current = next; setActive(true);
        next.addEventListener('release', () => setActive(false));
      } catch { /* unsupported or denied */ }
    };
    acquire();
    document.addEventListener('visibilitychange', acquire);
    return () => { disposed = true; document.removeEventListener('visibilitychange', acquire); release(); };
  }, [enabled, release]);
  return { active, release };
};